export default __webpack_public_path__ + "static/media/black-export-data-icon.58613586.svg";